import * as React from "react";
import type { SVGProps } from "react";

interface SuspensionTwoProps extends SVGProps<SVGSVGElement> {
  cancelled?: boolean;
}
const SuspensionTwo = ({ cancelled = false, ...props }: SuspensionTwoProps) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" {...props}>
    <g>
    <g fill="none" fillRule="evenodd">
      <g transform="translate(2.5 1)">
        <ellipse cx={9.75} cy={12.93} fill="#FFF" rx={8.09} ry={8.14} />
        <path
          fill="#000"
          fillRule="nonzero"
          stroke="#FFF"
          strokeLinejoin="round"
          strokeWidth={0.75}
          d="M10.99-.38A1.32 1.32 0 0 1 12.3.8c0 .47-.13.82-.35 1.07-.24.28-.58.44-.96.44l-.38.52a9.88 9.88 0 0 1 8.77 9.74 9.88 9.88 0 0 1-9.88 9.8 9.88 9.88 0 0 1-9.88-9.8A9.88 9.88 0 0 1 8.4 2.83V2.3c-.74 0-1.07-.15-1.31-.39a1.37 1.37 0 0 1 0-1.9c.23-.24.56-.4.93-.4H11ZM9.5 4.97a7.67 7.67 0 0 0-7.66 7.6 7.67 7.67 0 0 0 13.08 5.38 7.55 7.55 0 0 0 0-10.75A7.67 7.67 0 0 0 9.5 4.97Z"
        />
      </g>
      <path
        fill="#FF1212"
        fillRule="nonzero"
        d="M9.99 18.5q-.99 0-.99-.51c0-.44.07-.88.22-1.31s.4-.88.76-1.34.84-.97 1.45-1.51c.3-.28.58-.55.85-.83.27-.27.5-.54.66-.81.17-.27.26-.52.27-.76q.015-.66-.3-.99c-.22-.22-.53-.33-.94-.33-.51 0-.85.24-1.02.7-.1.28-.22.5-.36.65s-.36.23-.65.23a.85.85 0 0 1-.66-.27c-.16-.17-.2-.41-.13-.72.17-.7.5-1.24 1-1.63a2.9 2.9 0 0 1 1.82-.57c.58 0 1.1.12 1.57.35A2.6 2.6 0 0 1 15 11.47c-.01.46-.12.87-.32 1.24s-.48.73-.83 1.08q-.51.525-1.2 1.14c-.42.4-.8.79-1.14 1.15-.33.36-.53.65-.6.88h2.89c.66 0 .99.25.99.76 0 .52-.33.78-1 .78H10Z"
      />
    </g>
        {cancelled && (
        <rect
          width="25"
          height="2.5"
          x="-.494"
          y="10.746"
          fill="#000"
          fillRule="evenodd"
          stroke="#FFF"
          rx="1"
          transform="rotate(-45 12.006 11.996)"
        />
      )}
    </g>
  </svg>
);
export default SuspensionTwo;
